var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-items-report" },
    [
      _c("el-card", [
        _vm.cardData.title
          ? _c(
              "div",
              {
                staticClass: "clearfix",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_c("span", [_vm._v(_vm._s(_vm.cardData.title))])]
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.cardData.cardItems, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "box box-border" },
              [_c("card", { attrs: { item: item, onClick: _vm.toSetting } })],
              1
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }